import { render, staticRenderFns } from "./changeclose.vue?vue&type=template&id=6786e5e2&scoped=true&"
import script from "./changeclose.vue?vue&type=script&lang=js&"
export * from "./changeclose.vue?vue&type=script&lang=js&"
import style0 from "./changeclose.vue?vue&type=style&index=0&id=6786e5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786e5e2",
  null
  
)

export default component.exports